import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";

const hc_color = "#D90429";
const who_color = "#F4A261";

export function LineScatterChart({ table }) {
  const chartRef = useRef(null);

  useEffect(() => {
    const chartInstance = echarts.init(chartRef.current);

    const hc_data = table.map((item) => {
      return [String(item[0]), item[3]];
    });

    const who_data = table.map((item) => {
      return [String(item[0]), item[2]];
    });

    const all_years = table.map((item) => {
      return String(item[0]);
    });

    const max_who = Math.max(
      ...table.map((item) => {
        return item[2];
      })
    );

    const options = {
      tooltip: {
        trigger: "item",
        formatter: (params) =>
          `${params.seriesName}<br/>Year: ${params.value[0]}<br/>Failure Rate: ${params.value[1]}%`,
      },
      xAxis: {
        type: "category",
        // name: "Year",
        nameLocation: "middle",
        nameGap: 25,
        min: 0,
        max: all_years.length - 1,
        boundaryGap: false,
        data: all_years,
      },
      yAxis: {
        type: "value",
        name: "Failure Rate %",
        nameLocation: "middle",
        nameGap: 25,
        min: 0, // Set minimum y value
        max: 100, //Math.ceil(max_who),
      },
      series: [
        {
          name: "HC Exceedance",
          type: "scatter",
          symbolSize: 10,
          data: hc_data,
        },
        {
          name: "HC Exceedance",
          type: "line",
          data: hc_data,
          smooth: true,
        },
        {
          name: "WHO Exceedance",
          type: "scatter",
          symbolSize: 10,
          data: who_data,
        },
        {
          name: "WHO Exceedance",
          type: "line",
          data: who_data,
          smooth: true,
        },
      ],
      color: [hc_color, who_color], // Colors for series
      legend: {
        data: ["", "HC Exceedance", "", "WHO Exceedance"],
        top: "7%",
        left: "center",
      },
    };

    chartInstance.setOption(options);

    return () => {
      chartInstance.dispose();
    };
  }, [table]);

  return <div ref={chartRef} style={{ width: "100%", height: "400px" }} />;
}
